import * as React from 'react';
import { useEffect, useState } from 'react';
import './DarkModeSwitch.scss';

export const DarkModeSwitch = () => {
    const [currentTheme, setCurrentTheme] = useState<string>('auto');

    const getStoredTheme = () => localStorage.getItem('theme');
    const setStoredTheme = (theme: string) => localStorage.setItem('theme', theme);

    const getPreferredTheme = () => {
        const storedTheme = getStoredTheme();
        if (storedTheme) {
            return storedTheme;
        }
        return 'auto';
    };

    const setTheme = (theme: string) => {
        if (theme === 'auto') {
            document.documentElement.setAttribute('data-bs-theme', window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
        } else {
            document.documentElement.setAttribute('data-bs-theme', theme);
        }
    };

    useEffect(() => {
        const handleMediaChange = () => {
            const storedTheme = getStoredTheme();
            if (storedTheme !== 'light' && storedTheme !== 'dark') {
                setTheme(getPreferredTheme());
            }
        };

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', handleMediaChange);
        const initialTheme = getPreferredTheme();
        setCurrentTheme(initialTheme);
        setTheme(initialTheme);

        return () => {
            window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', handleMediaChange);
        };
    }, []);

    const handleDarkModeChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newTheme = event.target.value;
        setCurrentTheme(newTheme);
        setTheme(newTheme);
        setStoredTheme(newTheme);
    };

    return (
        <>
            <label htmlFor={`dark-mode-switch`} className="me-2">
                Välj tema
            </label>
            <select
                id={`dark-mode-switch`}
                className="form-select form-select-sm dark-mode-switch__select d-inline-block"
                onChange={handleDarkModeChange}
                value={currentTheme}
                title="Välj färgtema"
            >
                <option value="auto">Auto</option>
                <option value="light">Ljust</option>
                <option value="dark">Mörkt</option>
            </select>
        </>
    );
};
